import type { PlayerGuardianStatus } from '@/services/get-player-guardians';

export enum GuardianCircleMemberStatus {
  Active = 'active',
  Creator = 'creator',
  Joined = 'joined',
  Waiting = 'waiting',
  Expired = 'expired',
  Declined = 'declined',
}

/** Route params for the Invitation Sent (invitation details) screen. */
export type InvitationSentInfo = {
  id?: string;
  invitationCode?: string;
  guardianUid?: string;
  contact: string;
  /** Recipient's email — needed to resend the invitation (`contact` may fall back to a name). */
  email?: string;
  relationship?: string;
  status: PlayerGuardianStatus;
  expiresAt?: string;
  inviteUrl?: string;
  message?: string;
};

export type GuardianCircleMember = {
  id: string;
  /** Stable guardian identifier used to fetch the co-guardian profile / activities. */
  guardianUid?: string;
  invitationCode?: string;
  name: string;
  avatarUrl?: string;
  status: GuardianCircleMemberStatus;
  leadLabel: string;
  metaLabel?: string;
  isSelf?: boolean;
};

export type GuardianCircleData = {
  members: GuardianCircleMember[];
  activeAdultsCount: number;
  isPrimaryGuardian: boolean;
};
